import moment from 'moment'

export default {
    namespaced: true,
    state: {
        period: 'Denne uge',
        presets: [
            "I dag",
            "I går",
            "Denne uge",
            "Sidste uge",
            "Denne måned",
            "Sidste måned",
            "Dette år",
            "Selvvalgt"
        ],
        range: [
            moment()
                .startOf("isoweek")
                .format("YYYY-MM-DD"),
            moment()
                .endOf("isoweek")
                .format("YYYY-MM-DD")
        ]
    },
    mutations: {
        setRange: (state, preset) => {
            if (preset === "Seneste 30 dage") {
                state.range = [
                    moment()
                        .subtract(30, "days")
                        .format("YYYY-MM-DD"),
                    moment()
                        .format("YYYY-MM-DD")
                ]
            }
            else if (preset === "I dag") {
                state.range = [
                    moment()
                        .format("YYYY-MM-DD"),
                    moment()
                        .format("YYYY-MM-DD")
                ]
            } else if (preset === "I går") {
                state.range = [
                    moment()
                        .subtract(1, 'd')
                        .format("YYYY-MM-DD"),
                    moment()
                        .subtract(1, 'd')
                        .format("YYYY-MM-DD")
                ];
            } else if (preset === "Denne uge") {
                state.range = [
                    moment()
                        .startOf("isoweek")
                        .format("YYYY-MM-DD"),
                    moment()
                        .endOf("isoweek")
                        .format("YYYY-MM-DD")
                ];
            } else if (preset === "Sidste uge") {
                state.range = [moment()
                        .subtract(1, "weeks")
                        .startOf("isoweek")
                        .format("YYYY-MM-DD"),
                    moment()
                        .subtract(1, "weeks")
                        .endOf("isoweek")
                        .format("YYYY-MM-DD")
                ];
            } else if (preset === "Denne måned") {
                state.range = [
                    moment()
                        .startOf("month")
                        .format("YYYY-MM-DD"),
                    moment()
                        .format("YYYY-MM-DD")
                ];
            } else if (preset === "Sidste måned") {
                state.range = [
                    moment()
                        .subtract(1, "month")
                        .startOf("month")
                        .format("YYYY-MM-DD"),
                    moment()
                        .subtract(1, "month")
                        .endOf("month")
                        .format("YYYY-MM-DD")
                ];
            } else if (preset === "Dette år") {
                state.range = [
                    moment()
                        .startOf("year")
                        .format("YYYY-MM-DD"),
                    moment()
                        .format("YYYY-MM-DD")
                ];
            }
        }
    }
}